import { useState, useEffect } from "react"
import { useGlobalContext } from "../data/GlobalContext"
import { promotionsData } from "../data/PromotionData"
import ModulesLotteryDraw from "../promotions/promotion_modules/modules_lotterDraw"
import ModulePeraBayong from "../promotions/promotion_modules/modules_peraBayong"
import ModuleCQ9Funalo from "../promotions/promotion_modules/modules_cq9Funalo"
import ModuleLoveMagicSpin from "../promotions/promotion_modules/modules_loveMagicSpin"
import CountdownTimer from "../data/CountdownTimer"
import UserManual from "../UserManual"
import LoginToPlay from "../data/LoginToPlay"
const promoURL = process.env.REACT_APP_API_JSON_URL_PROMO

export default function SideContainer() {
  const [lotteryNumbers, setLotteryNumbers] = useState(null)
  const [isUserManual, setUserManual] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [activeModal, setActiveModal] = useState(null)
  const { setShowEasterEgg, showMysteryFridayBtn } = useGlobalContext()
  const [login, setLogin] = useState(false)

  const highlightPromotion = promotionsData
    .filter((promotion) => promotion.highlightPromotion)
    .sort((a, b) => a.priority - b.priority)

  useEffect(() => {
    document.body.style.overflow = activeModal ? "hidden" : "auto"
    return () => {
      document.body.style.overflow = "auto"
    }
  }, [activeModal])

  useEffect(() => {
    setIsLoggedIn(document.body.classList.contains("IsLoggedIn"))
  }, [])

  useEffect(() => {
    const getLotteryEntries = async () => {
      try {
        const response = await fetch(promoURL, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: "cmd=get230WinningNumbers",
        })
        const responseText = await response.text()
        const data = JSON.parse(responseText)

        // Only update state if there's a valid drawId.
        if (data.drawId !== "") {
          setLotteryNumbers(data)
        }
      } catch (error) {
        console.error("Error fetching lottery entries:", error)
      }
    }

    getLotteryEntries()
  }, [])

  const modalComponents = {
    "2/30 Lottery Draw": ModulesLotteryDraw,
    "Pera O Bayong": ModulePeraBayong,
    "CQ9 Funalo": ModuleCQ9Funalo,
    "JDB Spin Tournament": ModuleLoveMagicSpin,
  }
  const ActiveModal = activeModal ? modalComponents[activeModal] : null

  // const isPeraOBayongActive = () => {
  //   const now = new Date()
  //   const day = now.getDay() // Sunday = 0, Monday = 1, ..., Saturday = 6
  //   const hours = now.getHours()
  //   const minutes = now.getMinutes()

  //   if (day === 4 && hours >= 16) {
  //     // Thursday after 4:00 PM
  //     return true
  //   } else if (day === 5) {
  //     // Any time on Friday until 11:59 PM
  //     return true
  //   }
  //   return false
  // }

  const showUserManual = () => {
    setUserManual(true)
  }

  const showLogin = () => {
    setLogin(true)
  }
  return (
    <>
      {ActiveModal && <ActiveModal closeModal={() => setActiveModal(null)} />}
      {login && <LoginToPlay onClose={() => setLogin(false)} />}
      <div className="side-bar-container">
        {highlightPromotion.map((promotion) => (
          <div key={promotion.id} className="fgh-featured-promotion-wrapper">
            <div className="fgh-featured-promotion-item">
              <div className="fgh-featured-promotion-box">
                {/* <div className="fgh-snow-melting">
                  <img src="/images/icon/SNOW-MELTING.webp" alt="" />
                </div> */}
                <img
                  src={promotion.featuredImg}
                  alt={promotion.title}
                  className="fgh-featured-promotion-img"
                />
              </div>
              <p className="featured-promotion-status">
                {promotion.subHeading}
              </p>
              <div className="featured-promotion-details">
                <div className="featured-promotion-countdown">
                  <CountdownTimer {...promotion} />

                  {promotion.title === "Pera O Bayong" && (
                    <div className="lottery-draw-results-container">
                      <p>Choose Fortune</p>
                      {isLoggedIn ? (
                        showMysteryFridayBtn ? (
                          <button
                            onClick={() => setActiveModal(promotion.title)}
                            style={{
                              paddingInline: "20px",
                              width: "fit-content",
                            }}
                          >
                            Claim Prize
                          </button>
                        ) : (
                          <a
                            href="/profile#wallet"
                            style={{
                              paddingInline: "20px",
                              width: "fit-content",
                            }}
                          >
                            Claim Prize
                          </a>
                        )
                      ) : (
                        <button
                          onClick={showLogin}
                          style={{
                            paddingInline: "20px",
                            width: "fit-content",
                          }}
                        >
                          Claim Prize
                        </button>
                      )}
                    </div>
                  )}
                  {promotion.title === "CQ9 Funalo" && (
                    <div className="lottery-draw-results-container">
                      <p>Funalo Sa Pasko</p>
                      {isLoggedIn ? (
                        <button
                          onClick={() => setActiveModal(promotion.title)}
                          style={{
                            paddingInline: "20px",
                            width: "fit-content",
                          }}
                        >
                          Leaderboard
                        </button>
                      ) : (
                        <button
                          onClick={showLogin}
                          style={{
                            paddingInline: "20px",
                            width: "fit-content",
                          }}
                        >
                          Leaderboard
                        </button>
                      )}
                    </div>
                  )}
                  {promotion.title === "2/30 Lottery Draw" && (
                    <div className="lottery-draw-results-container">
                      <p>
                        Winning #{" "}
                        {lotteryNumbers && lotteryNumbers.drawId !== "" && (
                          <span>
                            {lotteryNumbers.number1} : {lotteryNumbers.number2}
                          </span>
                        )}
                      </p>
                      {isLoggedIn ? (
                        <button onClick={() => setActiveModal(promotion.title)}>
                          Guess now
                        </button>
                      ) : (
                        <button onClick={showLogin}>Guess now</button>
                      )}
                    </div>
                  )}
                </div>
                {/* Show lottery results container only for promotion with id 4 */}
              </div>
            </div>
            <div className="featured-promotion-info">
              <a
                href={promotion.tncLink}
                className="fgh-featured-promotion-btn"
              >
                <p>{promotion.title}</p>
              </a>
            </div>
          </div>
        ))}
        <div className="fgh-user-manual-icon">
          <img
            src="/images/icon/FGH-INFO.webp"
            alt=""
            onClick={showUserManual}
          />
        </div>
      </div>

      {isUserManual && (
        <>
          <UserManual closeUserManual={() => setUserManual(false)} />
        </>
      )}
    </>
  )
}
